import { render } from "./vue-countTo.vue?vue&type=template&id=6082f6f0"
import script from "./vue-countTo.vue?vue&type=script&lang=js"
export * from "./vue-countTo.vue?vue&type=script&lang=js"
script.render = render

export default script